<script setup lang="ts">
import type { DropdownMenuInstance } from 'vant'

enum LocaleMap {
  EN = 'en',
  TW = 'tw',
}

const { formatQuery } = useUseBeforeRequest()
const { t } = useI18n()
const localPath = useLocalePath()
const route = useRoute()
const { isLogin, userinfo } = useAuthStore()
// const searchStore = useHotSearchStore()

const dropdownMenuRef = ref<DropdownMenuInstance>()
const filter = ref<boolean>(true)
const filter2 = ref<boolean>(false)
const Lang = ref<LocaleMap>(LocaleMap.TW)

if ((route.name as string)!.includes('___en')) {
  Lang.value = LocaleMap.EN
}

const recipesList = ref<_CookBookItem[]>([])
// 加载中标识
const listLoading = ref<boolean>(false)
// 刷新标识
const refreshing = ref<boolean>(false)
// 全部加载完成标识
const finished = ref<boolean>(false)

const searchParams = reactive<{
  pageSize: number
  pageNo: number
  ctype?: number
  cdes?: number
  cookBookType?: string
  name?: string
}>({
  pageSize: 16,
  pageNo: 0,
})

// 临时筛选字段
const cookBookType = ref<{ [key: string]: any }>()
const filterData = useState<_TypeListPCRedis[]>('recipeFilterData', () => [])

const { status, data } = await useFetch<_ResponseType<_TypeListPCRedis[]>>('/api/wCookbookTypeNew/typeListPCRedis', {
  params: {
    language: Lang.value === LocaleMap.TW ? 'cn' : 'en',
  },
})

// function checkedLang() {
//   Lang.value = Lang.value === LocaleMap.TW ? LocaleMap.EN : LocaleMap.TW
//   setLocale(Lang.value)
// }

const searchValue = ref<string>()

if (route.query.keyword) {
  searchValue.value = route.query.keyword as string
}

const sortValue = ref(0) // 排序
const sortOption = [
  { text: t('sort.default'), value: 0 },
  { text: t('Points from high to low'), value: 1 },
  { text: t('Points from low to high'), value: 2 },
  { text: t('Number of views from high to low'), value: 3 },
  { text: t('Views from low to high'), value: 4 },
]

const integralValue = ref(0) // 所需积分
const integralOption = computed(() => {
  const isEn = Lang.value === LocaleMap.EN

  return [
    { text: isEn ? 'All' : '所有', value: 0 },
    { text: isEn ? 'free' : '免費', value: 1 },
    { text: isEn ? 'pay' : '付費', value: 2 },
  ]
})

const recipeTypeValue = ref(0) // 食谱类型
const recipeTypeOption = computed(() => {
  const isEn = Lang.value === LocaleMap.EN

  return [
    { text: isEn ? 'All' : '所有', value: 0 },
    { text: isEn ? 'Official Recipe' : '官方食谱', value: 1 },
    { text: isEn ? 'Member\'s Recipe' : '会员食谱', value: 2 },
    { text: isEn ? 'TOMIZ-Recipe' : 'TOMIZ-食谱', value: 3 },
  ]
})

// const show = ref(false)
// function showPopup() {
//   show.value = true
// }

// 添加食谱
function pushRecipe() {
  navigateTo(localPath('/recipe/form/add'))
}

// 换算工具
// function conversionTool() {
//   navigateTo(localPath('/toolManagement/conversionTool'))
// }
function handleOpenFilter() {
  filter.value = false
  filter2.value = true
}
function handleCloseFilter() {
  filter.value = true
  filter2.value = false
}

function initSearch() {
  recipeTypeValue.value = 0
  integralValue.value = 0
  searchValue.value = undefined
  // eslint-disable-next-line ts/ban-ts-comment
  // @ts-expect-error
  const keys = Object.keys(cookBookType.value)
  const cookBookTypeTemp: { [key: string]: any } = {}
  keys.forEach((key) => {
    cookBookTypeTemp[key] = 0
  })
  cookBookType.value = cookBookTypeTemp

  handleFilterSort()
}

function buildParams() {
  const params: any = {}
  searchParams.pageNo += 1
  params.pageSize = searchParams.pageSize
  params.pageNo = searchParams.pageNo
  if (isLogin) {
    params.customerId = userinfo?.id || 0
  }
  else {
    params.customerId = 0
  }
  if (cookBookType.value) {
    const tempCookBookType = Object.values(cookBookType.value).filter(item => item !== 0)
    if (tempCookBookType.length) {
      params.cookBookType = tempCookBookType.join(',')
    }
  }

  if (recipeTypeValue.value) {
    params.ctype = recipeTypeValue.value
  }
  if (integralValue.value === 1) {
    params.free = true
  }

  if (integralValue.value === 2) {
    params.free = false
  }

  params.cdes = sortValue.value

  // 搜索字段
  if (searchValue.value) {
    params.name = searchValue.value
  }

  return params
}

const listError = ref<boolean>(false)

const { status: _status, refresh, error: _error } = await useFetch<_ResponseType<_Pagination<_CookBookItem[]>>>('/api/wCookbook/list', {
  params: {
    MESSAGE: '',
  },
  onRequestError(_ctx) {
    listLoading.value = false
    listError.value = true
  },
  onResponseError(_ctx) {
    listLoading.value = false
    listError.value = true
  },
  onRequest({ options }) {
    if (!finished.value) {
      listLoading.value = true
      // 处理分页及其他
      const params = buildParams()
      options.params!.MESSAGE = formatQuery(params)
    }
  },
  onResponse({ response, error }) {
    listLoading.value = false
    // 处理响应数据
    refreshing.value = false

    if (error) {
      searchParams.pageNo = searchParams.pageNo -= 1
      console.error(error)
      listLoading.value = false
      listError.value = true
      return
    }

    if (response._data.data.records?.length === 0) {
      finished.value = true
    }
    if (response._data.data.records?.length < searchParams.pageSize) {
      finished.value = true
    }

    recipesList.value = [...recipesList.value, ...(response._data.data.records || [])]
  },
  dedupe: 'cancel',
  immediate: false,
  retry: 0,
})

watch(() => _status.value, (val) => {
  if (val === 'error') {
    listLoading.value = false
    listError.value = true
  }
}, {
  immediate: true,
})

watch(() => status.value, (val) => {
  if (val === 'success') {
    const tempCookBookType: { [key: string]: any } = {}
    const temp = (data?.value?.data || []).map((item: _TypeListPCRedis) => {
      tempCookBookType[item.id] = 0
      const cookBookTypeList = item.cookBookTypeList.map(_item => ({ ..._item, text: _item.name, value: _item.id }))
      const text = Lang.value === LocaleMap.EN ? 'All' : '所有'
      cookBookTypeList.unshift({ id: 0, text, name: text, value: 0, cbtype_id: item.id })
      return {
        ...item,
        cookBookTypeList,
      }
    }).filter((item: _TypeListPCRedis) => item.type === 'cookbook')

    cookBookType.value = tempCookBookType
    filterData.value = temp
  }
}, {
  deep: true,
  immediate: true,
})

// function searchBtn(item: any) {
//   if (item.type === 1) {
//     const keyword = item.id ? item.title : item.keyword
//     searchValue.value = keyword
//     searchStore.addSearchHistory({ keyword, type: 1 })
//     handleRefresh()
//   }
//   else {
//     // todo 点击hashTag逻辑
//   }

//   // searchValue.value = item.name
//   // show.value = false
// }

function handleFilterSort() {
  searchParams.pageNo = 0
  finished.value = false
  recipesList.value = []
  refresh()
}

// function handleSearch() {
//   // if (searchValue.value) {
//   //   searchStore.addSearchHistory({ keyword: searchValue.value, type: 1 })
//   // }
//   // searchParams.pageNo = 0
//   // finished.value = false
//   // recipesList.value = []
//   // refresh()
//   if (isInsideIframe)
//     return
//   navigateTo(localPath('/searchManagement/search?type=recipe'))
// }

function handleFetchData() {
  if (listError.value)
    return
  refresh()
}

function handleRefresh() {
  searchParams.pageNo = 0
  finished.value = false
  recipesList.value = []
  refresh()
}

function handleConfirm() {
  dropdownMenuRef.value?.close()
  searchParams.pageNo = 0
  finished.value = false
  recipesList.value = []
  refresh()
}

onBeforeMount(() => refresh())

const moreContent = ref('')

const { data: seoData, status: seoStatus } = await useFetch<_Seo[]>('/api/seoRelation/list', {
  method: 'POST',
  body: {
    paths: [useRoute().path],
  },
})

watch(() => seoStatus.value, (newVal) => {
  if (newVal === 'success') {
    if (seoData.value && Array.isArray(seoData.value) && seoData.value.length) {
      const { content } = JSON.parse(JSON.stringify(seoData.value)).pop()
      moreContent.value = content.content
      const { title, meta } = content
      useHead({
        title,
        meta,
      })
    }
  }
}, {
  immediate: true,
})

function goBack() {
  navigateTo(localPath('/recipe'), { replace: true })
  initSearch()
}
</script>

<template>
  <div>
    <div class="main">
      <van-sticky>
        <with-header with-search search-type="recipe" :client-left="goBack" />
        <!-- <div class="top">
          <div relative mb-10 w-full flex items-center justify-between>
            <div class="flex items-center">
              <van-icon name="arrow-left text-xl text-white" @click="goBack" />
            </div>
            <img
              class="absolute left-1/2 w-[70px] transform -translate-x-1/2"
              src="~/assets/image/logo.png"
              alt=""
              @click="navigateTo(localPath('/'))"
            >
            <div class="ml-auto flex items-center">
              <i class="i-bx-search mr-3 text-xl text-white" @click="handleSearch" />
              <svgo-weighing
                filled
                class="mr-3 text-xl"
                @click="conversionTool"
              />

              <div @click="checkedLang">
                <svgo-en
                  v-if="Lang !== LocaleMap.TW"
                  filled
                  class="text-xl"
                />
                <svgo-ft
                  v-else
                  filled
                  class="text-xl"
                />
              </div>
            </div>
          </div>
          <van-popup
            v-model:show="show"
            position="top"
            class="search-popup"
          >
            <div>
              <h2>{{ t("Search History") }}</h2>
              <van-button
                v-for="(item, index) in searchStore.recipeHistory"
                :key="index"
                class="search-btn"
                round
                size="small"
                color="#F7F7F7"
                @click="searchBtn(item)"
              >
                <div class="text-[#666666]">
                  {{ item.keyword }}
                </div>
              </van-button>
            </div>
            <div>
              <h2>{{ t("Popular recipes") }}</h2>
              <template v-for="item in searchStore.hotRecipesList" :key="item.id">
                <van-button
                  v-if="item.title"
                  class="search-btn"
                  round
                  size="small"
                  color="#F7F7F7"
                  @click="searchBtn(item)"
                >
                  <div class="text-[#666666]">
                    {{ item.title }}
                  </div>
                </van-button>
              </template>
            </div>
            <div>
              <h2>{{ t("Popular HASHTAG") }}</h2>
              <template v-for="item in searchStore.hotHashTagList" :key="item.id">
                <van-button
                  v-if="item.title"
                  class="search-btn"
                  round
                  size="small"
                  color="#F7F7F7"
                  @click="searchBtn(item)"
                >
                  <div class="text-[#666666]">
                    # {{ item.title }}
                  </div>
                </van-button>
              </template>
            </div>
          </van-popup>
        </div> -->
        <van-dropdown-menu ref="dropdownMenuRef" active-color="#743a3a">
          <van-dropdown-item
            @open="handleOpenFilter"
            @close="handleCloseFilter"
          >
            <template #title>
              <div
                flex
                items-center
              >
                <svgo-filter
                  v-if="filter"
                  filled
                  class=""
                />
                <svgo-filters2
                  v-if="filter2"
                  filled
                  class="text-xl"
                />
                <div mx-1>
                  {{ t("Filter") }}
                </div>
              </div>
            </template>
            <van-row
              :gutter="[20, 20]"
              class="choose-item"
            >
              <van-col v-for="item in filterData" :key="item.id" span="12">
                <div
                  flex
                  items-center
                  class="choose-item-title"
                >
                  <svgo-kitchenware v-if="item.id === 1" class="text-xl" />
                  <svgo-cuisine v-if="item.id === 2" class="text-xl" />
                  <svgo-simplicity v-if="item.id === 3" class="text-xl" />
                  <svgo-festival v-if="item.id === 5" class="text-xl" />
                  <div mx-1>
                    {{ item.name }}
                  </div>
                </div>
                <van-dropdown-menu active-color="#743a3a">
                  <van-dropdown-item
                    v-model="cookBookType![item.id.toString()]"
                    :options="item.cookBookTypeList"
                  />
                </van-dropdown-menu>
              </van-col>
              <van-col span="12">
                <div
                  flex
                  items-center
                  class="choose-item-title"
                >
                  <svgo-recipetype class="text-xl" />
                  <div mx-1>
                    {{ t("recipe type") }}
                  </div>
                </div>
                <van-dropdown-menu active-color="#743a3a">
                  <van-dropdown-item
                    v-model="recipeTypeValue"
                    :options="recipeTypeOption"
                  />
                </van-dropdown-menu>
              </van-col>
              <!-- <van-col span="12">
              <div
                flex
                items-center
                class="choose-item-title"
              >
                <svgo-time class="text-xl" />
                <div mx-1>
                  {{ t("time") }}
                </div>
              </div>
              <van-dropdown-menu active-color="#743a3a">
                <van-dropdown-item
                  v-model="festivalValue"
                  :options="option3"
                />
              </van-dropdown-menu>
            </van-col> -->
              <van-col span="12">
                <div
                  flex
                  items-center
                  class="choose-item-title"
                >
                  <svgo-use class="text-xl" />
                  <div mx-1>
                    {{ t("recipe.filter.title.integral") }}
                  </div>
                </div>
                <van-dropdown-menu active-color="#743a3a">
                  <van-dropdown-item
                    v-model="integralValue"
                    :options="integralOption"
                  />
                </van-dropdown-menu>
              </van-col>
              <van-col span="12">
                <van-button
                  round
                  color="#743a3a"
                  @click="handleConfirm"
                >
                  <div fw-600>
                    {{ t("confirm") }}
                  </div>
                </van-button>
              </van-col>
              <van-col span="12">
                <van-button
                  round
                  plain
                  color="#743a3a"
                  @click="initSearch"
                >
                  <div fw-600>
                    {{ t("Clear all filters") }}
                  </div>
                </van-button>
              </van-col>
            </van-row>
          </van-dropdown-item>
          <van-dropdown-item
            v-model="sortValue"
            :options="sortOption"
            @change="handleFilterSort"
          >
            <template #title>
              <div
                flex
                items-center
              >
                <svgo-sort
                  filled
                  class="text-xl"
                />
                <div mx-1>
                  {{ t("Sorting") }}
                </div>
              </div>
            </template>
          </van-dropdown-item>
        </van-dropdown-menu>
      </van-sticky>

      <client-only>
        <van-pull-refresh
          v-model="refreshing"
          @refresh="handleRefresh"
        >
          <van-list
            v-model:loading="listLoading"
            v-model:error="listError"
            :finished="finished"
            :offset="100"
            :immediate-check="false"
            error-text="加載失敗，請點擊重試"
            @load="handleFetchData"
          >
            <div
              class="content"
              mt-5
            >
              <recipe-list :recipes="recipesList" />
            </div>
          </van-list>
        </van-pull-refresh>
      </client-only>
      <SeoMoreContent :content="moreContent" class="fixed bottom-80px left-0 right-0" />
      <div
        class="fixed bottom-130px right-20px h-[70px] w-[70px]"
        @click="pushRecipe"
      >
        <img
          class="h-full w-full"
          src="~/assets/image/postsp.png"
          alt=""
        >
      </div>
      <!-- <span @click="pushRecipe" class="fixed bottom-100px right-20px">
        <svgo-postsp filled class=""/>
      </span> -->
    </div>
    <app-tabbar />
  </div>
</template>

<style scoped lang="scss">
.main {
  padding-bottom: 30px;
  min-height: calc(100vh - 70px - 8px);
  // overflow-y: scroll;
  background-color: #f7f7f7;

  .top {
    width: 100%;
    height: 52px;
    background-color: #743a3a;
    padding: 1.3rem 0.9375rem 0;
    position: relative;
    .logo {
      width: 4.125rem;
      height: 2.75rem;
    }
    .Weighing {
      width: 1.375rem;
      height: 1.375rem;
    }
    // .custom-switch {
    //   .text-en,
    //   .text-zh {
    //     font-size: 12px;
    //     color: #fff;
    //     position: absolute;
    //     width: 100%;
    //     text-align: center;
    //     z-index: 1;
    //   }
    // }
    .custom-switch {
      position: relative;
    }

    .switch-content {
      font-size: 12px;
      color: #fff;
      position: absolute;
      width: 50%;
      text-align: center;
      z-index: 2;
      left: 50%;
      transform: translateX(-50%);
    }

    .custom-switch::before {
      content: '繁';
      font-size: 12px;
      color: #743a3a;
      position: absolute;
      left: 5px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }

    .custom-switch::after {
      content: 'EN';
      font-size: 12px;
      color: #743a3a;
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }

    :deep(.van-cell) {
      border-radius: 1.875rem;
    }
    :deep(.van-overlay) {
      top: 160px;
    }
    :deep(.van-popup--top) {
      top: 160px;
    }
    :deep(.van-popup) {
      transition: none;
    }
    .search-popup {
      height: 30%;
      padding: 20px;
      h2 {
        font-weight: 600;
      }
      .search-btn {
        margin: 10px 10px 10px 0;
      }
    }
  }

  .content {
    text-align: left;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 14px;
    padding: 0 17px;
    margin-bottom: 1.875rem;
  }
  .choose-item {
    margin: 0 10px;
    padding: 20px 0;
    .choose-item-title {
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: 600;
      color: #743a3a;
      img {
        width: 20px;
        height: 20px;
      }
    }
    :deep(.van-dropdown-menu__bar) {
      background: #f2e9ea;
      border-radius: 5px;
      height: 40px;
    }
    :deep(.van-dropdown-menu__item) {
      justify-content: space-between;
    }
    :deep(.van-dropdown-menu__title:after) {
      border-color: transparent transparent var(--van-gray-6) var(--van-gray-6);
    }

    .van-button {
      width: 100%;
      margin-top: 25px;
    }
  }
}
</style>
